import { LogoMark } from "@/components/brand/Logo";
import { Link } from "react-router-dom";

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden px-5 py-12">
      <div className="bs-aurora pointer-events-none absolute inset-0 opacity-60" />
      <div className="bs-grid-bg pointer-events-none absolute inset-0" />
      <div className="relative w-full max-w-md">
        <div className="mb-8 text-center">
          <Link to="/" className="inline-flex flex-col items-center gap-3">
            <LogoMark size={48} />
            <span className="font-display text-xl font-extrabold tracking-tight">Buddy <span className="bs-gradient-text">Solution</span></span>
          </Link>
        </div>
        <div className="rounded-3xl border border-border bs-glass p-7 shadow-soft sm:p-8">
          <h1 className="font-display text-2xl font-bold">{title}</h1>
          {subtitle && <p className="mt-1.5 text-sm text-muted-foreground">{subtitle}</p>}
          <div className="mt-6">{children}</div>
        </div>
        {footer && <div className="mt-6 text-center text-sm text-muted-foreground">{footer}</div>}
      </div>
    </div>
  );
}
